import styled from "styled-components";
import { FooterSection, LeadingTitle } from "@components";
import AnnualReportTabs from "./Components/Tabs/Tabs";
import { useState, useEffect } from "react";
import { ShortDescriptionAPI } from "@api";
import { useTranslation } from "react-i18next";

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const AnnualReport = function () {
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({ loc: "lap_tahunan" });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  }, [shortDesc]);
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t("laporan_tahunan")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />
      <AnnualReportTabs />
      <FooterSection currentPage={t("laporan_tahunan")}/>
    </InvestorContainer>
  );
};

export default AnnualReport;
